// GameClientProvider.tsx (Client Component)
'use client';

import React, {useCallback, useEffect} from 'react';
import {GlobalEventEmitter, PLOWDisplayHandler} from '@sdk-mobile';
import GameProvider from '@/app/(app)/games/[gid]/_src/GameProviders/GameProvider';
import useReplaySettings, {ReplaySettings} from '@/app/(app)/games/[gid]/_src/hooks/useReplaySettings';
import FTUEGameProvider from '@/app/(app)/games/[gid]/_src/GameProviders/FTUEGameProvider';
import {useRouter, useSearchParams} from 'next/navigation';
import useWebviewMessaging, {LOAD_MODE, LoadMode} from '@/utils/useWebViewMessaging';

type Props = {
  children: React.ReactNode;
  gid: string;
  gameCdnUrl: string;
  matchToken: string;
};

export default function GameClientProvider({children, gid, gameCdnUrl, matchToken}: Props) {
  const {replaySettings} = useReplaySettings(3600000);
  const searchParams = useSearchParams();
  const router = useRouter();
  const loadModeParam = searchParams.get('loadMode') as LoadMode;
  const preLoadGames = searchParams.get('preLoadGames')?.split(',') ?? [];
  const addStartMatchListener = useCallback((startMatch: (details: any) => void) => {
    return GlobalEventEmitter.addListener('startMatch', startMatch);
  }, []);

  const displayResults = useCallback((match: any) => {
    PLOWDisplayHandler.displayResultsFromSubmitScore(match);
  }, []);

  useEffect(() => {
    function preFetch(gameId: string) {
      router.prefetch(`/games/${gameId}/home`);
    }
    const gameIds = preLoadGames.filter((id) => id !== gid);
    console.log({gameIds});
    gameIds.forEach(preFetch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadMode = useWebviewMessaging({
    filter: (state) => state.loadMode,
    defaultState: {
      loadMode: loadModeParam || LOAD_MODE.FULL,
      currentGame: gid,
    },
    onMessage: (message) => {
      if (message.type === 'currentGame') {
        router.push(`/games/${message.body}/home`);
      }
    },
  });

  return (
    <FTUEGameProvider>
      <GameProvider
        loadMode={loadMode as LoadMode}
        gid={gid}
        gameCdnUrl={gameCdnUrl}
        addStartMatchListener={addStartMatchListener}
        replaySettings={replaySettings as ReplaySettings}
        displayResults={displayResults}
        matchToken={matchToken}
      >
        {children}
      </GameProvider>
    </FTUEGameProvider>
  );
}
